module.exports = __webpack_public_path__ + "img/fourday_ps_30.0cfb1f3a.jpg";